import React from "react";

import Link from "next/link";

import { OpenNewWindowIcon } from "@/components/icons-lib";

interface SectionTitleNavLinkProps {
  href: string;
  label: string;
}

export const SectionTitleNavLink: React.FC<SectionTitleNavLinkProps> = ({
  href,
  label,
}) => {
  return (
    <Link
      className="flex items-center gap-2 text-sm font-medium text-darkRed-700"
      href={href}
      rel="noopener noreferrer"
      target="_blank"
    >
      {label}
      <OpenNewWindowIcon className="h-5 w-5 shrink-0 text-darkRed-700" />
    </Link>
  );
};
